import React from 'react';

import Dropzone from 'react-dropzone';

import { MIME_TYPES } from '../../constants/FileUploadConstants';
import { PermittedFileType } from '../../declarations';
import AddFileUploadElement from '../agentResaleOfferFlow/AddFileUploadElement';

export interface IOnePdfUploadProps {
  acceptedFileTypes?: PermittedFileType[];
  maxSize?: number;
  minSize?: number;
  onClickUploadButton?: () => void;
  onDropAccepted?: (file: File) => void;
  onDropRejected?: (file: File[]) => void;
}

export default class OnePdfUpload extends React.Component<IOnePdfUploadProps> {
  public static defaultProps: Partial<IOnePdfUploadProps> = {
    acceptedFileTypes: [MIME_TYPES.pdf],
  };

  public render(): JSX.Element {
    const { acceptedFileTypes, maxSize, minSize, onClickUploadButton, onDropRejected } = this.props;

    return (
      <Dropzone
        accept={!!acceptedFileTypes && acceptedFileTypes.join()}
        acceptClassName="accepted"
        activeClassName="active"
        className="one-pdf-upload"
        onClick={onClickUploadButton}
        onDropAccepted={this.onDroppedFileAccepted}
        onDropRejected={onDropRejected}
        maxSize={maxSize}
        minSize={minSize}
        rejectClassName="error"
      >
        <AddFileUploadElement className="upload-pdf" content="Upload a PDF to split" />
      </Dropzone>
    );
  }

  private onDroppedFileAccepted = newFile => {
    this.props.onDropAccepted(newFile[0]);
  };
}
